import slate from '@react-page/plugins-slate';
// import css as well. currently, we caannot do this here in the demo project and have moved that to _app.tsx
// see https://github.com/vercel/next.js/issues/19717
// import '@react-page/plugins-slate/lib/index.css';
import React from 'react';
import customSlatePlugin from './customSlatePlugin';
import katexSlatePlugin from './katexSlatePlugin';
import styled from 'styled-components';
export const defaultSlate = slate((def) => (Object.assign(Object.assign({}, def), { plugins: Object.assign(Object.assign({}, def.plugins), { 
        // you can also add custom plugins. The namespace `custom` is just for organizing plugins
        custom: {
            custom1: customSlatePlugin,
            katex: katexSlatePlugin,
        } }) })));
// you can further customize slate to your needs
export const customizedSlate = slate((def) => (Object.assign(Object.assign({}, def), { name: def.id + '/reduced', hideInMenu: true, plugins: {
        // here we do not use all plugins, but select them
        headings: {
            h2: def.plugins.headings.h2,
            // you can also customize default slate plugins easily!
            // e.g. change just the style:
            h3: def.plugins.headings.h3((d) => {
                return Object.assign(Object.assign({}, d), { 
                    // we can override properties, like `getStyle`:
                    getStyle: (props) => { var _a; return (Object.assign(Object.assign({}, (_a = d.getStyle) === null || _a === void 0 ? void 0 : _a.call(d, props)), { color: 'magenta' })); } });
            }),
            //  we can also replace the component that renders the plugin
            h4: def.plugins.headings.h4((d) => {
                return Object.assign(Object.assign({}, d), { Component: (props) => {
                        return (
                        // be sure to mixin attributes, this is required for slate
                        React.createElement("h4", Object.assign({ style: props.style }, props.attributes),
                            React.createElement("span", { contentEditable: false, role: "img", "aria-label": "Ladybug" }, "\uD83D\uDC1E"),
                            props.children,
                            React.createElement("span", { contentEditable: false, role: "img", "aria-label": "Heart" },
                                ' ',
                                "\u2764\uFE0F")));
                    } });
            }),
            h5: def.plugins.headings.h5((d) => {
                return Object.assign(Object.assign({}, d), { 
                    // if you use styled-components, you can use it as well
                    Component: styled.h5 `
            text-decoration: underline;
            font-style: italic;
          ` });
            }),
        },
        paragraphs: def.plugins.paragraphs,
        emphasize: def.plugins.emphasize,
        alignment: def.plugins.alignment,
    } })));
//# sourceMappingURL=slate.js.map